"use strict";

exports.__esModule = true;
exports.ScheduleWorkdayOffsetField = ScheduleWorkdayOffsetField;
var _react = _interopRequireDefault(require("react"));
var _reactFinalForm = require("react-final-form");
var _core = require("@blueprintjs/core");
var _WorkdayOffsetSelector = require("./WorkdayOffsetSelector");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ScheduleWorkdayOffsetField() {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
    name: "workdayOffset"
  }, function (_ref) {
    var input = _ref.input,
      meta = _ref.meta;
    return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      intent: meta.touched && meta.error ? "danger" : "secondary",
      helperText: meta.touched && meta.error ? meta.error : translate("ScheduleWorkdayOffsetField.helperText", "The workday offset of this schedule."),
      label: translate("ScheduleWorkdayOffsetField.label", "Workday Start Time"),
      labelFor: "workdayOffset",
      requiredLabel: "*"
    }, /*#__PURE__*/_react["default"].createElement(_WorkdayOffsetSelector.WorkdayOffsetSelector, input));
  });
}